import ExternalIframe from 'components/shared/containers/ExternalIframe';
import PageContainer from 'components/shared/containers/PageContainer';
import { CenterContentContainer } from 'components/shared/containers/PageLayoutContainer';
import ContentHeaderView from 'components/shared/views/ContentHeaderView';
import PageContentView from 'components/shared/views/PageContentView';
import React from 'react';
import { useModel,useBCMSContext,BCMSRecord,DisabledPrompt } from "bcms-react";
import Classes, { Profile } from "model";
import { ProfilePicker } from '../ChangeProfilePage';
import "./styles.css";
import "./mobile.css"; 
/**
 * @function PaymentsPage
 * @return {React.Component}
 * @note - Branding for this page is being added to the window object so captures can utilize the set value in state code
 * @exported true
 * @description The main component for PaymentsPage  
 */
export default function PaymentsPage(props) {
  // Branding options needed for captures
  const branding = useModel().branding.options;
  let model = useModel();
  window.BRANDING = { "rxp17_abi22" : branding.rxp17_abi22 };
  const label = branding.payments_label_abi22 ?? "Payments";
  const paymentDemo = model.demos.RXP17 ? "RXP17": "RXP22"; 
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);
  const profiles = Profile.initAll(); 
  return (
    <PageContainer className="payments-page integrated-product-page" ignoreTrigger={ true }>
      <PageContentView>
      {branding.multiprofile_abi22 ==="true" &&

   
          <ProfilePicker profiles = {profiles} ui={{}} onChange = {()=>{}} onSelectClick={()=>{}} disableBusiness="true"/>
      
      }           
        <CenterContentContainer>
          <ContentHeaderView text={label}/>
         
          <div className="iframe-container flex-container flex-horizontal justify-center">
                  
            {/* iFrame for RXP17 goes here */}
            <ExternalIframe className="payments-iframe" demo={paymentDemo} key="PaymentsPage"/>
          </div>
        </CenterContentContainer>
      </PageContentView>
    </PageContainer>
  );
}
